import { applyMiddleware, createStore } from "redux";
import rootReducer from "./rootReducer";
import { composeWithDevTools } from "redux-devtools-extension";

//create middleware
const myLogger = (store) => (next) => (action) => {
    const currentState = store.getState();

    switch (action.type) {
        case 'productItems/DecrementQuantity':
            const productQuantity = currentState.productItems.products[action.payload].quantity;
            if (productQuantity === 0) {
                alert('Product is out of stock.');
                break;
            } else {
                return next(action);
            }
        case 'cart/AddToCart':
            const isQtyNull = currentState.productItems.products[action.payload.id].quantity;
            if (isQtyNull === 0) {
                break;
            } else {
                return next(action);
            }
        default:
            return next(action);
    }
}

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(myLogger)));

export default store;